import { useState } from "react";
import type { Account } from "../lib/types";

export function AccountInformation({ account }: { account: Account }) {
  const [message, setMessage] = useState("");
  async function copy(value: string) {
    try { await navigator.clipboard.writeText(value); setMessage("Nummer kopiert."); }
    catch { setMessage("Bitte die angezeigte Nummer markieren und kopieren."); }
  }
  return <section className="management-card account-information">
    <h1>Mein Konto</h1>
    <p>Diese Angaben helfen deiner Einrichtung, dein Konto eindeutig zu finden. Du kannst sie auch deinen Sorgeberechtigten weitergeben.</p>
    <dl><dt>Kontonummer</dt><dd><strong>{account.accountNumber ?? "Nicht vorhanden"}</strong><button className="secondary no-print" disabled={!account.accountNumber} onClick={() => void copy(account.accountNumber!)}>Kopieren</button></dd>
      {account.organizations.map((organization) => <div key={organization.id}><dt>Einrichtung</dt><dd>{organization.name}</dd><dt>Einrichtungsnummer</dt><dd><strong>{organization.organizationNumber ?? "Nicht vorhanden"}</strong>{organization.organizationNumber && <button className="secondary no-print" onClick={() => void copy(organization.organizationNumber!)}>Kopieren</button>}</dd></div>)}
    </dl>
    <button className="secondary no-print" onClick={() => window.print()}>Kontoinformation drucken</button>
    <p className="no-print" role="status">{message}</p>
  </section>;
}
